import { Budget } from '../../../../@types/budget';
import api from '../../../../services/api/api';
import { CreateBudgetInput } from '../CreateBudgetForm/interfaces';
import { EditBudgetInput } from './interfaces';

export const createBudgetDraft = async (budgetData: CreateBudgetInput) => {
  const res = await api.post<Budget>('/budget/draft', budgetData);
  return res;
};
export const updateBudgetDraft = async (budgetData: EditBudgetInput) => {
  const res = await api.put<Budget>('/budget', budgetData);
  return res;
};

export const transformBudgetDraft = async (budgetDraftId: string) => {
  const res = await api.post<Budget>(
    `/budget/draft/transform/${budgetDraftId}`,
  );
  return res;
};
